import { render, staticRenderFns } from "./ViewApplicantProfile.vue?vue&type=template&id=efdccbc6&scoped=true&"
import script from "./ViewApplicantProfile.vue?vue&type=script&lang=js&"
export * from "./ViewApplicantProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdccbc6",
  null
  
)

export default component.exports